var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('vx-left-menu',{attrs:{"show":_vm.showLeftMenu,"id-incendio-selected":_vm.idIncendioSelected,"sim-collapsed":_vm.simCollapsed},on:{"exit":_vm.hideLeftMenu}}),_c('vx-map',{attrs:{"show-incendios-cards":_vm.showIncendiosCards},on:{"selectIncendio":_vm.selectIncendio,"isSimCollapsed":_vm.handleCollapse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }